import { render, staticRenderFns } from "./ColumnsWrapDesign.vue?vue&type=template&id=64fb2f7e&"
import script from "./ColumnsWrapDesign.vue?vue&type=script&lang=ts&"
export * from "./ColumnsWrapDesign.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnsWrapDesign.vue?vue&type=style&index=0&id=64fb2f7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports